import React from "react";
import GoalCard from "./GoalCard";
import { useLanguage } from "../../i18n/LanguageContext";

const GoalList = ({ goals, onEditGoal, onDeleteGoal, onGoalClick }) => {
  const { t } = useLanguage();
  const priorityOrder = {
    High: 1,
    Medium: 2,
    Low: 3,
  };

  const sortedGoals = [...goals].sort((a, b) => {
    const priorityA = priorityOrder[a.priority] || 4;
    const priorityB = priorityOrder[b.priority] || 4;
    return priorityA - priorityB;
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {sortedGoals.map((goal) => (
        <GoalCard
          key={goal.id || goal.goal_id}
          goal={goal}
          onEdit={onEditGoal}
          onDelete={onDeleteGoal}
          onClick={onGoalClick}
        />
      ))}
      {goals.length === 0 && (
        <p className="col-span-full text-center text-gray-500 italic">
          {t("goals.empty")}
        </p>
      )}
    </div>
  );
};

export default GoalList;
